import { Component, Input, OnInit} from "@angular/core";
import { FormGroup} from "@angular/forms";
import { IFormComponent } from "../entitybuilder/edit-entity.component";

@Component({
    templateUrl: "./string-form.component.html",
    standalone: false
})
export class StringFormComponent implements IFormComponent, OnInit {
    @Input() title: string;
    @Input() data: any;
    @Input() parent?: string;
    @Input() formComponent: FormGroup;

    ngOnInit(): void {
        if (this.title === "items") {
            this.name.disable();       
        }
    }

    get name() { return this.formComponent.get("name"); }
    get format() { return this.formComponent.get("format"); }
    get allowEdit() { return this.formComponent.get("allowEdit"); }
    //Needed for Data correction, and potentially for Data Warehouse.
    get isOrganizationId() { return this.formComponent.get("isOrganizationId"); }

    //DisplayName and DataSource originally added for dataCorrection, but values input no longer used by data correction
    //still leaving for now
    get displayName() { return this.formComponent.get("displayName"); }
}
